export const LoginValues = {
  username: '',
  password: '',
}

export const newsLetterValues = {
  firstName: '',
  lastName: '',
  email: '',
}

export const forgotUsernameValues = {
  email: '',
}

export const forgotPasswordValues = {
  username: '',
}

export const clientValues = {
  displayName: '',
  emailId: '',
  password: '',
  confirmPassword: '',
  username: '',
  firstName: '',
  middleName: '',
  lastName: '',
  refferedProfession: '',
  otherProfession: '',
  intakeTypeId: '',
  // signupIp: '',
  reCaptcha: '',
  agreeTerms: false,
}

export const ResetPasswordValues = {
  password: '',
  confirmPassword: '',
}

export const FeedbackValues = {
  FeedbackSource: '',
  Feedbackoption: '',
  Feedbackoptionother: '',
}

export const ReferClientValues = {
  firstname: '',
  lastname: '',
  emailaddress: '',
}

export const UploadMapValues = {
  firstname: '',
  lastname: '',
  emailaddress: '',
  pdfFile: '',
}

export const AddMapToProfessionalValues = {
  professionalmail: '',
}
export const clientEditProfileValues = {
  firstName: '',
  middlName: '',
  lastName: '',
  nickName: '',
  email: '',
  refferedProfession: '',
  otherProfession: '',
}

export const AttorneyPasswordUpdateValues = {
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
}

export const ChangeUsernameValues = {
  oldUsername: '',
  username: '',
}

export const helplineValues = {
  name: '',
  option: [],
  options: {
    email: '',
    phone: '',
    mailing: '',
    other: '',
  },
  email: '',
  phone: '',
  mailingAddress: '',
  otherContact: '',
  helplineSource: '',
  helplineSourceOther: '',
  problemSource: '',
  problemSourceOther: '',
  question: '',
  yesOrno: '',
  otherInfo: '',
  reCaptcha: '',
}

export const editProfessionalValues = {
  firstName: '',
  lastName: '',
  emailId: '',
  secondEmail: '',
  thirdEmail: '',
  phone: '',
  lawOffice: '',
  barAdmissionNo: '',
  isBarAdmissionGood: '',
  countryName: '',
  stateName: '',
  countyName: '',
  countryKey: '',
  stateKey: '',
  countyKey: '',
  barAdmissionNotes: '',
  workDescription: '',
}
export const professionalValues = {
  firstName: '',
  lastName: '',
  confirmPassword: '',
  emailId: '',
  username: '',
  password: '',
  lawOffice: '',
  barAdmissionNo: '',
  isBarAdmissionGood: '',
  barAdmissionNotes: '',
  countryKey: '',
  countryName: '',
  stateKey: '',
  stateName: '',
  countyKey: '',
  countyName: '',
  isNewsletterSubscribed: true,
  phone: '',
  workDescription: '',
  iAgreeTerms: false,
  reCaptcha: '',
  statesLength: 0,
}

export const AttorneySignupValues = {
  question: {
    answer: {
      answer1: '',
      answer2: '',
      answer3: '',
      answer4: '',
      answer5: '',
      answer6: '',
      answer7: '',
    },
  },
}

export const fieldsToStore = [
  'caseType',
  'currentSectionNo',
  'faceSheetCurrentPageNo',
  'preSectionCurrentPageNo',
  'intakeCurrentPageNo',
  'isIntakeCompleted',
  'isPreSectionCompleted',
  'isFaceSheetCompleted',
  'mapType',
  'isCompleted',
  'q158Answer',
  'q240Answer',
]
